import { programCreationStepViewed } from 'services/typewriter';
import {
  getEntity,
  segmentCompanyObject,
  segmentBrandObject,
  segmentProgramObject, segmentContextObject
} from './helpers';

export default async ({ program, stepName }: Data) => {
  const company = await getEntity('companies', program['company']);
  const brand = await getEntity('brands', program['brand']);
  programCreationStepViewed({
    context: segmentContextObject(company, brand),
    company: segmentCompanyObject(company),
    brand: segmentBrandObject(brand, company),
    program: segmentProgramObject(program),
    stepName,
  });
};
